import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import StripePaywall from "./shared/StripePaywall";

const apiUrl = process.env.REACT_APP_API_URL || "https://api-backend.full-trucking-service.com/api";

// Mapare din DB (package) → ruta URL
const PACKAGE_TO_ROUTE = {
  "Basic":            "basic",
  "Standard":         "standart",
  "Premium":          "premium",
  "Business":         "business",
  "Ultimate":         "ultimate",
  "Enterprise":       "enterprise",
  "Simple Statement": "simple-statement",
  "Custom":           "custom",
};

const PrivateRoute = () => {
  const [status, setStatus]     = useState("loading");
  const [userRoute, setUserRoute] = useState(null); // ex: "ultimate"
  const [clientId, setClientId]   = useState(null);
  const location = useLocation();

  useEffect(() => {
    const checkAccess = async () => {
      const token           = localStorage.getItem("token");
      const tokenExpiration = localStorage.getItem("tokenExpiration");
      const storedClientId  = localStorage.getItem("clientId");

      // 1. Verifică token
      if (!token || !tokenExpiration || new Date() >= new Date(tokenExpiration)) {
        setStatus("unauthenticated");
        return;
      }

      try {
        // 2. Fetch client din DB
        const res = await axios.get(
          `${apiUrl}/clients/${storedClientId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const client = res.data;

        // 3. Mapează package → rută
        // client.package = "Ultimate" → "ultimate"
        const route = PACKAGE_TO_ROUTE[client.package] || client.package?.toLowerCase();
        setUserRoute(route);
        setClientId(storedClientId);

        // 4. Verifică subscription
        if (client.subscriptionStatus === "active") {
          setStatus("active");
        } else if (client.subscriptionStatus === "trialing") {
          const now = new Date();
          if (client.trialEndsAt && new Date(client.trialEndsAt) > now) {
            setStatus("trial");
          } else {
            setStatus("expired");
          }
        } else {
          setStatus("expired");
        }

      } catch (err) {
        console.error("Error checking access:", err);
        setStatus("unauthenticated");
      }
    };

    checkAccess();
  }, []);

  // ── Render states ──────────────────────────────────────
  if (status === "loading")         return <div>Loading...</div>;
  if (status === "unauthenticated") return <Navigate to="/login" replace />;
  if (status === "expired")         return <StripePaywall />;

  // ── Protecție rută ─────────────────────────────────────
  // location.pathname = "/client/business/6720d2cd..."
  //                              ↑ [2]
  const segments      = location.pathname.split('/');
  const requestedPlan = segments[2]; // "business", "premium", etc.

  const validPlans = Object.values(PACKAGE_TO_ROUTE); 
  // ["basic", "standart", "premium", "business", "ultimate", "enterprise", "simple-statement", "custom"]

  if (validPlans.includes(requestedPlan) && requestedPlan !== userRoute) {
    // Redirecționează la planul corect cu clientId
    return <Navigate to={`/client/${userRoute}/${clientId}`} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;